export default "__VITE_ASSET__BpJHHDIQ__"